import * as React from 'react'
import { MenuRowShortcutKbd } from '@/components/ui/shortcut-kbd'

import {
  ContextMenuItem,
  ContextMenuSeparator,
  EditorContextMenuShell,
} from '../editor-context-menu-shell'

export interface TextInlineEditContextMenuProps {
  open: boolean
  position: { x: number; y: number }
  onOpenChange: (open: boolean) => void
  viewportBoundsRef?: React.RefObject<HTMLElement | null>
  selectionCollapsed: boolean
  pastePlainDisabled: boolean
  onCut?: () => void
  onCopy?: () => void
  onPaste?: () => void
  onSelectAll?: () => void
  onSelectNone?: () => void
  onCheckSpelling?: () => void
  onInsertSpecialCharacter?: () => void
}

export function TextInlineEditContextMenu({
  open,
  position,
  onOpenChange,
  viewportBoundsRef,
  selectionCollapsed,
  pastePlainDisabled,
  onCut,
  onCopy,
  onPaste,
  onSelectAll,
  onSelectNone,
  onCheckSpelling,
  onInsertSpecialCharacter,
}: TextInlineEditContextMenuProps) {
  const handleItemClick = (handler?: () => void | Promise<void>) => {
    void Promise.resolve(handler?.()).finally(() => {
      onOpenChange(false)
    })
  }

  const cutDisabled = selectionCollapsed || !onCut
  const copyDisabled = selectionCollapsed
  const selectNoneDisabled = selectionCollapsed || !onSelectNone

  return (
    <EditorContextMenuShell
      open={open}
      position={position}
      onOpenChange={onOpenChange}
      viewportBoundsRef={viewportBoundsRef}
    >
      <ContextMenuItem
        onClick={onCut ? () => handleItemClick(onCut) : undefined}
        disabled={cutDisabled}
      >
        Cut
        <MenuRowShortcutKbd shortcutKey="cut" />
      </ContextMenuItem>
      <ContextMenuItem onClick={() => handleItemClick(onCopy)} disabled={copyDisabled}>
        Copy
        <MenuRowShortcutKbd shortcutKey="copy" />
      </ContextMenuItem>
      <ContextMenuItem
        onClick={onPaste ? () => handleItemClick(onPaste) : undefined}
        disabled={pastePlainDisabled || !onPaste}
      >
        Paste
        <MenuRowShortcutKbd shortcutKey="paste" />
      </ContextMenuItem>

      <ContextMenuSeparator />

      <ContextMenuItem onClick={onSelectAll ? () => handleItemClick(onSelectAll) : undefined}>
        Select All
        <MenuRowShortcutKbd shortcutKey="selectAll" />
      </ContextMenuItem>
      <ContextMenuItem
        onClick={onSelectNone ? () => handleItemClick(onSelectNone) : undefined}
        disabled={selectNoneDisabled}
      >
        Select None
        <MenuRowShortcutKbd shortcutKey="selectNone" />
      </ContextMenuItem>

      <ContextMenuSeparator />

      <ContextMenuItem
        onClick={onCheckSpelling ? () => handleItemClick(onCheckSpelling) : undefined}
        disabled={!onCheckSpelling}
      >
        Check Spelling
      </ContextMenuItem>
      <ContextMenuItem
        onClick={
          onInsertSpecialCharacter ? () => handleItemClick(onInsertSpecialCharacter) : undefined
        }
        disabled={!onInsertSpecialCharacter}
      >
        Insert Special Character
      </ContextMenuItem>
    </EditorContextMenuShell>
  )
}
